import { PLAYER_ZONE } from '../constants.js';

export function resolveDisplayZone(schema) {
  schema.slides.forEach((slide) => {
    slide._displayZone = PLAYER_ZONE;
  });
  return schema;
}
